import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Swords, ArrowLeft } from "lucide-react";

export default function TermsOfService() {
  const navigate = useNavigate();
  const [text, setText] = useState(null);

  useEffect(() => {
    fetch("/terms-of-service.txt")
      .then((r) => r.text())
      .then(setText)
      .catch(() => setText("Unable to load Terms of Service. Please contact admin@lanistamanager.com."));
  }, []);

  const blocks = (text || "").split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  const isHeading = (b) => b.length < 90 && (b === b.toUpperCase() || /^\d+\.\s/.test(b)) && !b.endsWith(".");

  return (
    <div data-testid="terms-page" className="min-h-screen bg-zinc-950 flex flex-col">
      <header className="border-b border-amber-900/30 bg-zinc-900/40">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <button data-testid="terms-back-btn" onClick={() => navigate("/")}
            className="flex items-center gap-2 text-zinc-400 hover:text-amber-300 transition-colors text-sm">
            <ArrowLeft size={16} /> Back
          </button>
          <div className="flex items-center gap-2.5">
            <Swords className="text-amber-500" size={18} />
            <span className="font-cinzel text-sm tracking-[0.25em] uppercase text-amber-300">Lanista — Gladiator Manager</span>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-6 py-12">
          <h1 className="font-cinzel text-3xl sm:text-4xl uppercase tracking-wide text-amber-300 mb-8">Terms of Service</h1>
          {text === null ? (
            <p className="text-zinc-500 text-sm">Loading…</p>
          ) : (
            <div className="space-y-4">
              {blocks.map((b, i) =>
                isHeading(b) ? (
                  <h2 key={i} className="font-cinzel text-lg text-amber-200/90 uppercase tracking-wide pt-4">{b}</h2>
                ) : (
                  <p key={i} className="text-zinc-400 text-sm leading-relaxed whitespace-pre-line">{b}</p>
                )
              )}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
